declare global {
  interface Window {
    // Dreamdata tracking tool for marketing analysis
    dreamdata?: {
      /**
       * Identifies a user in the Dreamdata system.
       * @param id - The user ID (can be null).
       * @param data - Additional user data, such as email.
       */
      identify?: (id: string | null, data: {email: string}) => void;

      /**
       * Tracks an event in the Dreamdata system.
       * @param event - The name of the event to track.
       */
      track?: (event: string) => void;
    };

    // Google Tag Manager's data layer for tracking events
    dataLayer?: Array<Record<string, unknown>>;
  }
}

export async function sendSuccessEventToMarketingTrackingTool(email: string) {
  if (email) {
    await window.dreamdata?.identify?.(null, {email});
  }

  window.dreamdata?.track?.('Free Trial success');
}

export const GTM_EVENTS = {
  FORM_SUBMITTED: () => {
    if (window?.dataLayer) {
      window.dataLayer.push({event: 'formSubmit', formId: 'signup_trial'});
    }
  },
};
